"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const Storage = async_storage_1.default;
const getExpireDate = (expireInMinutes) => {
    const now = new Date();
    const expireTime = new Date(now);
    expireTime.setMinutes(now.getMinutes() + expireInMinutes);
    return expireTime;
};
const setItem = async (key, objValue, //object or array
expireInMinutes) => {
    let data = { value: objValue };
    if (expireInMinutes) {
        const expireAt = getExpireDate(expireInMinutes);
        data.expireAt = expireAt;
    }
    else {
        // const expireAt = JSON.parse(await AsyncStorage.getItem(key))?.expireAt;
        data.expireAt = "";
        const expireAt = "";
        if (expireAt) {
            data.expireAt = expireAt;
        }
        else {
            // return;
        }
    }
    const objectToStore = JSON.stringify(data);
    return Storage.setItem(key, objectToStore);
};
const getItem = async (key, isString) => {
    let data = await Storage.getItem(key);
    data = data ? JSON.parse(data) : isString ? "" : {};
    if (data && data?.expireAt && new Date(data?.expireAt) < new Date()) {
        console.log("cache expired..!", key);
        await async_storage_1.default.removeItem(key);
        data = null;
    }
    // console.log("Cache data:", key, data?.value);
    return data?.value || (isString ? "" : {});
};
const removeItem = (key) => {
    Storage.removeItem(key);
};
const clear = () => {
    Storage.clear();
};
exports.default = {
    setItem,
    getItem,
    removeItem,
    clear,
};
